import React from 'react'
import { useTranslation } from 'react-i18next'

const AboutSection: React.FC = () => {
    const { t } = useTranslation()

    return (
        <section
            style={{
                padding: '60px 20px',
                backgroundColor: '#f4f2e8',
                textAlign: 'center'
            }}
        >
            <h2 style={{ fontSize: '2rem' }}>{t('about.title')}</h2>
            <p
                style={{
                    maxWidth: 800,
                    margin: '20px auto',
                    fontSize: '1.2rem'
                }}
            >
                {t('about.text')}
            </p>
        </section>
    )
}

export default AboutSection
